import type {
    IModuleHeadline,
    IModuleHeadlineFields,
    IPageGeneric,
    ISiteSettings,
} from "@contentful-api/types/contentful";
import { ModulesRenderer } from "@lib/contentful/modules-renderer/ModulesRenderer";
import { Box } from "@ui/components/layout/box/Box";
import dynamic from "next/dynamic";

const Headline = dynamic(() =>
    import("@components/cms/headline/Headline").then((mod) => mod.Headline)
);

export type GenericPageProps = {
    page: IPageGeneric;
    siteSettings: ISiteSettings;
};

export const GenericPage = ({ siteSettings, page }: GenericPageProps) => {
    const {
        fields: {
            modules,
            title,
            titleSize = "Extra Large",
            desc,
            descriptionSize = "Normal",
            callToActions,
        } = {},
    } = page;
    const { fields: { authorizationInvitation } = {} } = siteSettings;

    return (
        <>
            {(title || desc) && (
                <Headline
                    module={
                        {
                            fields: {
                                title,
                                desc,
                                callToActions,
                                // We need to cast because the types are not exactly the same
                                titleSize: titleSize as IModuleHeadlineFields["titleSize"],
                                descriptionSize,
                            },
                        } as IModuleHeadline
                    }
                    isModule={false}
                />
            )}
            <Box px={{ base: 3, xl: 4 }}>
                <ModulesRenderer
                    modules={modules}
                    authorizationInvitation={authorizationInvitation}
                />
            </Box>
        </>
    );
};
